import { call, all, put, takeEvery } from 'redux-saga/effects';
import moment from 'moment';

import callApi, { callDownload } from 'utils/callApi';
import insuranceEligibilityToPDF from 'utils/insuranceEligibilityToPDF';

import dateFormat from 'config/dateFormat';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';
import { createPatientDocument, createPatientDocumentSuccess } from 'redux/modules/patientsDocuments';

// Actions
export const FETCH_PATIENT_INSURANCE = 'FETCH_PATIENT_INSURANCE';
export const FETCH_PATIENT_INSURANCE_SUCCESS = 'FETCH_PATIENT_INSURANCE_SUCCESS';
export const FETCH_PATIENT_INSURANCE_FAIL = 'FETCH_PATIENT_INSURANCE_FAIL';
export const CREATE_PATIENT_INSURANCE = 'CREATE_PATIENT_INSURANCE';
export const CREATE_PATIENT_INSURANCE_SUCCESS = 'CREATE_PATIENT_INSURANCE_SUCCESS';
export const CREATE_PATIENT_INSURANCE_FAIL = 'CREATE_PATIENT_INSURANCE_FAIL';
export const UPDATE_PATIENT_INSURANCE = 'UPDATE_PATIENT_INSURANCE';
export const UPDATE_PATIENT_INSURANCE_SUCCESS = 'UPDATE_PATIENT_INSURANCE_SUCCESS';
export const UPDATE_PATIENT_INSURANCE_FAIL = 'UPDATE_PATIENT_INSURANCE_FAIL';
export const DELETE_PATIENT_INSURANCE = 'DELETE_PATIENT_INSURANCE';
export const DELETE_PATIENT_INSURANCE_SUCCESS = 'DELETE_PATIENT_INSURANCE_SUCCESS';
export const DELETE_PATIENT_INSURANCE_FAIL = 'DELETE_PATIENT_INSURANCE_FAIL';
export const CHECK_PATIENT_INSURANCE_ELIGIBILITY = 'CHECK_PATIENT_INSURANCE_ELIGIBILITY';
export const CHECK_PATIENT_INSURANCE_ELIGIBILITY_SUCCESS = 'CHECK_PATIENT_INSURANCE_ELIGIBILITY_SUCCESS';
export const CHECK_PATIENT_INSURANCE_ELIGIBILITY_FAIL = 'CHECK_PATIENT_INSURANCE_ELIGIBILITY_FAIL';
export const DOWNLOAD_EXPLAIN_PATIENT_INSURANCE_ELIGIBILITY = 'DOWNLOAD_EXPLAIN_PATIENT_INSURANCE_ELIGIBILITY';
export const CREATE_PATIENT_INSURANCE_SPECIAL_DATE = 'CREATE_PATIENT_INSURANCE_SPECIAL_DATE';
export const CREATE_PATIENT_INSURANCE_SPECIAL_DATE_SUCCESS = 'CREATE_PATIENT_INSURANCE_SPECIAL_DATE_SUCCESS';
export const CREATE_PATIENT_INSURANCE_SPECIAL_DATE_FAIL = 'CREATE_PATIENT_INSURANCE_SPECIAL_DATE_FAIL';
export const UPDATE_PATIENT_INSURANCE_SPECIAL_DATE = 'UPDATE_PATIENT_INSURANCE_SPECIAL_DATE';
export const UPDATE_PATIENT_INSURANCE_SPECIAL_DATE_SUCCESS = 'UPDATE_PATIENT_INSURANCE_SPECIAL_DATE_SUCCESS';
export const UPDATE_PATIENT_INSURANCE_SPECIAL_DATE_FAIL = 'UPDATE_PATIENT_INSURANCE_SPECIAL_DATE_FAIL';
export const DELETE_PATIENT_INSURANCE_SPECIAL_DATE = 'DELETE_PATIENT_INSURANCE_SPECIAL_DATE';
export const DELETE_PATIENT_INSURANCE_SPECIAL_DATE_SUCCESS = 'DELETE_PATIENT_INSURANCE_SPECIAL_DATE_SUCCESS';
export const DELETE_PATIENT_INSURANCE_SPECIAL_DATE_FAIL = 'DELETE_PATIENT_INSURANCE_SPECIAL_DATE_FAIL';

// Reducer
export default function patientsInsuranceReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type, payload } = action;
  switch (type) {
    case CREATE_PATIENT_INSURANCE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem['Record Number'] !== payload['Record Number']) {
          return dataItem;
        }

        return {
          ...dataItem,
          'Insurance Information': [
            ...dataItem['Insurance Information'].slice(0, dataItem['Insurance Information'].length),
            payload['Insurance Information'],
          ],
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case UPDATE_PATIENT_INSURANCE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (!dataItem['Insurance Information']) {
          return dataItem;
        }

        const newInsurance = dataItem['Insurance Information'].map((insuranceItem) => {
          if (insuranceItem.ID !== payload.ID) {
            return insuranceItem;
          }

          return {
            ...insuranceItem,
            ...payload,
          };
        });

        return {
          ...dataItem,
          'Insurance Information': newInsurance,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case DELETE_PATIENT_INSURANCE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem['Record Number'] !== payload['Record Number']) {
          return dataItem;
        }
        const index = dataItem['Insurance Information'].findIndex(item => item.ID === payload.ID);
        const newInsuranceInformation = [
          ...dataItem['Insurance Information'].slice(0, index),
          ...dataItem['Insurance Information'].slice(index + 1),
        ];
        return {
          ...dataItem,
          'Insurance Information': newInsuranceInformation,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case CHECK_PATIENT_INSURANCE_ELIGIBILITY: {
      const newData = state.data.map((dataItem) => {
        if (!dataItem['Insurance Information']) {
          return dataItem;
        }

        const newInsurance = dataItem['Insurance Information'].map((insuranceItem) => {
          if (insuranceItem.ID !== payload['Insurance ID']) {
            return insuranceItem;
          }

          return {
            ...insuranceItem,
            'Checking Eligibility': true,
          };
        });

        return {
          ...dataItem,
          'Insurance Information': newInsurance,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case CHECK_PATIENT_INSURANCE_ELIGIBILITY_SUCCESS:
    case CHECK_PATIENT_INSURANCE_ELIGIBILITY_FAIL: {
      const newData = state.data.map((dataItem) => {
        if (dataItem['Record Number'] !== payload['Patient ID'] || !dataItem['Insurance Information']) {
          return dataItem;
        }
        const newInsurance = dataItem['Insurance Information'].map((insuranceItem) => {
          if (insuranceItem.ID !== payload['Insurance ID']) {
            return insuranceItem;
          }
          return {
            ...insuranceItem,
            'Checking Eligibility': false,
          };
        });
        return {
          ...dataItem,
          'Insurance Information': newInsurance,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case CREATE_PATIENT_INSURANCE_SPECIAL_DATE_SUCCESS: {
      const newData = state.data.map((item) => {
        const newInsurance = item['Insurance Information'].map((insuranceItem) => {

          const createdInsuranceSpecialDate = payload.data.filter(specialDateItem =>
            specialDateItem['Insurance ID'] === item.ID);
          if (createdInsuranceSpecialDate.length > 0) {
            return {
              ...insuranceItem,
              'Insurance Special Date': [
                ...insuranceItem['Insurance Special Date'],
                ...createdInsuranceSpecialDate,
              ],
            };
          }

          return insuranceItem;
        });
        return {
          ...item,
          'Insurance Information': newInsurance,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case UPDATE_PATIENT_INSURANCE_SPECIAL_DATE_SUCCESS: {
      const newData = state.data.map((item) => {
        const newInsurance = item['Insurance Information'].map((insuranceItem) => {
          const newInsuranceSpecialDate = insuranceItem['Insurance Special Date'].map((specialDateItem) => {
            const updatedSpecialDate = payload.data.find(payloadItem =>
              payloadItem.ID === specialDateItem.ID);
            return updatedSpecialDate || specialDateItem;
          });

          return {
            ...insuranceItem,
            'Insurance Special Date': newInsuranceSpecialDate,
          };
        });
        
        return {
          ...item,
          'Insurance Information': newInsurance,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case DELETE_PATIENT_INSURANCE_SPECIAL_DATE_SUCCESS: {
      const newData = state.data.map((item) => {
        const newInsurance = item['Insurance Information'].map((insuranceItem) => {
          const newInsuranceSpecialDate = insuranceItem['Insurance Special Date'].filter(specialDateItem =>
            !payload.data.find(payloadItem =>
              payloadItem.ID === specialDateItem.ID));
          return {
            ...insuranceItem,
            'Insurance Special Date': newInsuranceSpecialDate,
          };
        });

        return {
          ...item,
          'Insurance Information': newInsurance,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    default:
      return state;
  }
}

// Action Creators
export function fetchPatientInsurance(payload) {
  return { type: FETCH_PATIENT_INSURANCE, payload };
}

export function fetchPatientInsuranceSuccess(payload) {
  return { type: FETCH_PATIENT_INSURANCE_SUCCESS, payload };
}

export function fetchPatientInsuranceFail(payload) {
  return { type: FETCH_PATIENT_INSURANCE_FAIL, payload };
}

export function createPatientInsurance(payload) {
  return { type: CREATE_PATIENT_INSURANCE, payload };
}

export function createPatientInsuranceSuccess(payload) {
  return { type: CREATE_PATIENT_INSURANCE_SUCCESS, payload };
}

export function createPatientInsuranceFail(payload) {
  return { type: CREATE_PATIENT_INSURANCE_FAIL, payload };
}

export function updatePatientInsurance(payload) {
  return { type: UPDATE_PATIENT_INSURANCE, payload };
}

export function updatePatientInsuranceSuccess(payload) {
  return { type: UPDATE_PATIENT_INSURANCE_SUCCESS, payload };
}

export function updatePatientInsuranceFail(payload) {
  return { type: UPDATE_PATIENT_INSURANCE_FAIL, payload };
}

export function deletePatientInsurance(payload) {
  return { type: DELETE_PATIENT_INSURANCE, payload };
}

export function deletePatientInsuranceSuccess(payload) {
  return { type: DELETE_PATIENT_INSURANCE_SUCCESS, payload };
}

export function deletePatientInsuranceFail(payload) {
  return { type: DELETE_PATIENT_INSURANCE_FAIL, payload };
}

export function checkPatientInsuranceEligibility(payload) {
  return { type: CHECK_PATIENT_INSURANCE_ELIGIBILITY, payload };
}

export function checkPatientInsuranceEligibilitySuccess(payload) {
  return { type: CHECK_PATIENT_INSURANCE_ELIGIBILITY_SUCCESS, payload };
}

export function checkPatientInsuranceEligibilityFail(payload) {
  return { type: CHECK_PATIENT_INSURANCE_ELIGIBILITY_FAIL, payload };
}

export function downloadExplainPatientInsuranceEligibility(payload) {
  return { type: DOWNLOAD_EXPLAIN_PATIENT_INSURANCE_ELIGIBILITY, payload };
}

export function createPatientInsuranceSpecialDate(payload) {
  return { type: CREATE_PATIENT_INSURANCE_SPECIAL_DATE, payload };
}

export function createPatientInsuranceSpecialDateSuccess(payload) {
  return { type: CREATE_PATIENT_INSURANCE_SPECIAL_DATE_SUCCESS, payload };
}

export function createPatientInsuranceSpecialDateFail(payload) {
  return { type: CREATE_PATIENT_INSURANCE_SPECIAL_DATE_FAIL, payload };
}

export function updatePatientInsuranceSpecialDate(payload) {
  return { type: UPDATE_PATIENT_INSURANCE_SPECIAL_DATE, payload };
}

export function updatePatientInsuranceSpecialDateSuccess(payload) {
  return { type: UPDATE_PATIENT_INSURANCE_SPECIAL_DATE_SUCCESS, payload };
}

export function updatePatientInsuranceSpecialDateFail(payload) {
  return { type: UPDATE_PATIENT_INSURANCE_SPECIAL_DATE_FAIL, payload };
}

export function deletePatientInsuranceSpecialDate(payload) {
  return { type: DELETE_PATIENT_INSURANCE_SPECIAL_DATE, payload };
}

export function deletePatientInsuranceSpecialDateSuccess(payload) {
  return { type: DELETE_PATIENT_INSURANCE_SPECIAL_DATE_SUCCESS, payload };
}

export function deletePatientInsuranceSpecialDateFail(payload) {
  return { type: DELETE_PATIENT_INSURANCE_SPECIAL_DATE_FAIL, payload };
}

// Requests
export function requestFetchPatientInsurance(payload) {
  return callApi(`patient/insurance/?id=${payload}`);
}

export function requestCreatePatientInsurance(payload) {
  return callApi('patient/insurance/', 'POST', payload);
}

export function requestUpdatePatientInsurance(payload) {
  return callApi('patient/insurance/', 'PATCH', payload);
}

export function requestDeletePatientInsurance(payload) {
  return callApi(`patient/insurance/?id=${payload.ID}`, 'DELETE');
}

export function requestCheckPatientInsuranceEligibility(payload) {
  return callApi('claim_md/eligibility/', 'POST', payload);
}

export function requestExplainPatientInsuranceEligibility(payload) {
  return callDownload(`claim_md/eligibility/explain/?ID=${payload.ID}`, 'GET', payload.fileName);
}

export function requestCreatePatientInsuranceSpecialDate(payload) {
  return callApi('resource/insurance_special_date/', 'POST', payload);
}

export function requestUpdatePatientInsuranceSpecialDate(payload) {
  return callApi('resource/insurance_special_date/', 'PATCH', payload);
}

export function requestDeletePatientInsuranceSpecialDate(payload) {
  return callApi(`resource/insurance_special_date/?id=${payload.ID}`, 'DELETE');
}


// Sagas
function* fetchPatientInsuranceSaga(action) {
  const { triggerLoading, ID } = action.payload;
  try {
    const res = yield call(requestFetchPatientInsurance, ID);
    if (res.data.ID) {
      yield put(fetchPatientInsuranceSuccess({
        ...res.data,
        triggerLoading,
      }));
      yield put(fetchAccountInformationSuccess(res.user_info));
      yield put(fetchAppInfoSuccess(res.app_info));
    } else {
      yield put(fetchPatientInsuranceFail({
        triggerLoading,
      }));
    }
  } catch (err) {
    yield put(fetchPatientInsuranceFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* createPatientInsuranceSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestCreatePatientInsurance, values);
    yield put(createPatientInsuranceSuccess({
      'Record Number': values['User Record Number'],
      'Insurance Information': res.data,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'New insurance successfully added',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createPatientInsuranceFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* updatePatientInsuranceSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestUpdatePatientInsurance, values);
    yield put(updatePatientInsuranceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Insurance successfully updated',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(updatePatientInsuranceFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* deletePatientInsuranceSaga(action) {
  try {
    const res = yield call(requestDeletePatientInsurance, action.payload);
    yield put(deletePatientInsuranceSuccess(action.payload));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Insurance successfully deleted',
      variant: 'success',
    }));
  } catch (err) {
    yield put(deletePatientInsuranceFail(err.data));
    yield put(addNotification({
      message: err.data.error || err.data,
      variant: 'warning',
    }));
  }
}

function* checkPatientInsuranceEligibilitySaga(action) {
  try {
    const res = yield call(requestCheckPatientInsuranceEligibility, {
      'Insurance ID': action.payload['Insurance ID'],
    });
    if (res.data.error && res.data.error.length > 0) {
      yield put(addNotification({
        message: res.data.error,
        variant: 'warning',
        ...res.data.explain ? {
          actionHref: process.env.REACT_APP_API_ROOT
            ? `${process.env.REACT_APP_API_ROOT}${res.data.explain['File Url']}${res.data.explain['File Name']}`
            : `${res.data.explain['File Url']}${res.data.explain['File Name']}`,
          actionText: 'Download Details',
          download: process.env.REACT_APP_API_ROOT
            ? `${process.env.REACT_APP_API_ROOT}${res.data.explain['File Url']}${res.data.explain['File Name']}`
            : `${res.data.explain['File Url']}${res.data.explain['File Name']}`,
        } : {},
      }));
      if (res.data.explain && res.data.explain.ID) {
        yield put(createPatientDocumentSuccess({
          'Record Number': action.payload['Patient ID'],
          Documents: [res.data.explain],
        }));
      }
      yield put(checkPatientInsuranceEligibilityFail({
        'Patient ID': action.payload['Patient ID'],
        'Insurance ID': action.payload['Insurance ID'],
        error: res.data.error,
      }));
      yield put(fetchAccountInformationSuccess(res.user_info));
      yield put(fetchAppInfoSuccess(res.app_info));
    } else {
      const insuranceEligibility = yield call(insuranceEligibilityToPDF, {
        insuranceEligibility: res.data.Result,
        payerName: action.payload['Payer Name'],
      });

      const eligibilityPDF = {
        blob: insuranceEligibility.output('blob'),
        Name: `${action.payload['Payer Name']} Insurance Eligibility as of ${moment().format(dateFormat)}-${res.data.ID}`,
      };

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        const fileBlob = eligibilityPDF.blob;
        fileBlob.lastModifiedDate = new Date();
        yield put(createPatientDocument({
          values: {
            'Record Number': action.payload['Patient ID'],
            Document: fileBlob,
            Name: `${eligibilityPDF.Name}.pdf`,
          },
        }));
      } else {
        const file = new File(
          [eligibilityPDF.blob],
          `${eligibilityPDF.Name}.pdf`,
          { type: 'application/pdf', lastModified: Date.now() },
        );
        yield put(createPatientDocument({
          values: {
            'Record Number': action.payload['Patient ID'],
            Document: file,
          },
        }));
      }
      yield put(addNotification({
        message: 'Insurance eligibility validated, result placed in document secton',
        variant: 'success',
      }));
      yield put(checkPatientInsuranceEligibilitySuccess({
        'Patient ID': action.payload['Patient ID'],
        'Insurance ID': action.payload['Insurance ID'],
      }));
      yield put(fetchAccountInformationSuccess(res.user_info));
      yield put(fetchAppInfoSuccess(res.app_info));
    }
  } catch (err) {
    yield put(addNotification({
      message: 'Clearing house validation error',
      variant: 'warning',
    }));
    yield put(checkPatientInsuranceEligibilityFail({
      'Patient ID': action.payload['Patient ID'],
      'Insurance ID': action.payload['Insurance ID'],
      error: err.data.error,
    }));
  }
}

function* downloadExplainPatientInsuranceEligibilitySaga(action) {
  try {
    yield call(requestExplainPatientInsuranceEligibility, action.payload);
  } catch (err) {
    yield put(addNotification({
      message: 'Failed to Download Eligibility Details',
      variant: 'warning',
    }));
  }
}

function* createPatientInsuranceSpecialDateSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield all(values['Insurance Special Date'].map(item =>
      call(requestCreatePatientInsuranceSpecialDate, {
        ...item,
        'Insurance ID': values['Insurance ID'],
      }),
    ));
    yield put(fetchAccountInformationSuccess(res[0].user_info));
    yield put(fetchAppInfoSuccess(res[0].app_info));
    yield put(createPatientInsuranceSpecialDateSuccess({ data: res.map(item => item.data) }));
    if (resolve) {
      resolve(res.map(item => item.data));
    }
  } catch (err) {
    yield put(createPatientInsuranceSpecialDateFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* updatePatientInsuranceSpecialDateSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield all(values['Insurance Special Date'].map(item =>
      call(requestUpdatePatientInsuranceSpecialDate, item),
    ));
    yield put(fetchAccountInformationSuccess(res[0].user_info));
    yield put(fetchAppInfoSuccess(res[0].app_info));
    yield put(updatePatientInsuranceSpecialDateSuccess({ data: res.map(item => item.data) }));
    if (resolve) {
      resolve(res.map(item => item.data));
    }
  } catch (err) {
    yield put(updatePatientInsuranceSpecialDateFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* deletePatientInsuranceSpecialDateSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield all(values['Insurance Special Date'].map(item =>
      call(requestDeletePatientInsuranceSpecialDate, item),
    ));
    yield put(fetchAccountInformationSuccess(res[0].user_info));
    yield put(fetchAppInfoSuccess(res[0].app_info));
    console.log(res);
    yield put(deletePatientInsuranceSpecialDateSuccess({ data: values['Insurance Special Date'] }));
    if (resolve) {
      resolve(values['Insurance Special Date']);
    }
  } catch (err) {
    yield put(deletePatientInsuranceSpecialDateFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

export function* patientsInsuranceSaga() {
  yield takeEvery(FETCH_PATIENT_INSURANCE, fetchPatientInsuranceSaga);
  yield takeEvery(CREATE_PATIENT_INSURANCE, createPatientInsuranceSaga);
  yield takeEvery(UPDATE_PATIENT_INSURANCE, updatePatientInsuranceSaga);
  yield takeEvery(DELETE_PATIENT_INSURANCE, deletePatientInsuranceSaga);
  yield takeEvery(CHECK_PATIENT_INSURANCE_ELIGIBILITY, checkPatientInsuranceEligibilitySaga);
  yield takeEvery(DOWNLOAD_EXPLAIN_PATIENT_INSURANCE_ELIGIBILITY,
    downloadExplainPatientInsuranceEligibilitySaga);
  yield takeEvery(CREATE_PATIENT_INSURANCE_SPECIAL_DATE, createPatientInsuranceSpecialDateSaga);
  yield takeEvery(UPDATE_PATIENT_INSURANCE_SPECIAL_DATE, updatePatientInsuranceSpecialDateSaga);
  yield takeEvery(DELETE_PATIENT_INSURANCE_SPECIAL_DATE, deletePatientInsuranceSpecialDateSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/patientsInsurance.js